import { fetcher } from '@commenda/utils';

import {
  IIndirectTaxFilingV2BulkDeleteParams,
  IIndirectTaxFilingV2BulkDeleteResponse,
  IIndirectTaxFilingV2MutationResult,
} from './types';

export async function bulkDeleteIndirectTaxFilingsV2({
  params,
  token,
}: {
  params: IIndirectTaxFilingV2BulkDeleteParams;
  token?: string;
}): Promise<
  IIndirectTaxFilingV2MutationResult<IIndirectTaxFilingV2BulkDeleteResponse>
> {
  try {
    const response = await fetcher(
      'new-sales-tax/filings-v2/bulk/delete',
      { method: 'DELETE', body: params },
      token
    );
    const json = await response.json();
    if (!response.ok) {
      return {
        success: false,
        error: json?.message || 'Failed to bulk delete filings',
      };
    }
    const data: IIndirectTaxFilingV2BulkDeleteResponse = json;
    return { success: true, data };
  } catch (error) {
    return {
      success: false,
      error:
        error instanceof Error
          ? error.message
          : 'Failed to bulk delete filings',
    };
  }
}
